import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { isMobile } from "react-device-detect";

const steps = [
  {
    selector: ".addon-0",
    content: <><strong>Tip:</strong> Select any addon service</>,
    position: "bottom",
  },
];

// import Tour from "reactour";
const Tour = dynamic(() => import("reactour"), { ssr: false });

const ProductAddonTourFlow = ({ }) => {
  const [isTourOpen, setIsTourOpen] = useState(true);
  const [productTour, setProductTour] = useState(false);
  const router = useRouter();

  useEffect(() => {
    let tourDataCheck = localStorage.getItem("product-addon-tour");
    if (tourDataCheck || router.pathname != "/services/[...slug]") {
      return;
    }

    if (isMobile) {
      return;
    }

    setTimeout(() => {
      setProductTour(true);
      localStorage.setItem("product-addon-tour", true);
    }, 1000);
  }, []);


  return (
    <>
      {productTour && (
        <Tour
          steps={steps}
          isOpen={isTourOpen}
          onRequestClose={() => setIsTourOpen(false)}
          showButtons={false}
          showNavigation={false}
          showNavigationNumber={false}
          showNumber={false}
        />
      )}
    </>
  );
};

export default ProductAddonTourFlow;
